import script from "./ViolationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationList.vue?vue&type=script&setup=true&lang=js"

import "./ViolationList.vue?vue&type=style&index=0&id=4a44d60c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a44d60c"]])

export default __exports__